import GSAP from 'gsap'

export default class ImageParallax {
	constructor() {

		this.images 			= GSAP.utils.toArray('[data-speed="auto"]')
		this.calculateHeight 	= this.calculateHeight.bind(this)
		this.createTriggers 	= this.createTriggers.bind(this)
		
		this.createTriggers()

	}

	createTriggers() {

		if( window.app.lenis !== null 
			&& this.images 
			&& !window.app.isMobile
			&& !window.app.isTouch
		){

			this.images.forEach((image) => {

				if(image.ST) {
					// Check for existing scrolltrigger to avoid duplicates
					image.ST.scrollTrigger.refresh()
				
				} else {

					const offset = this.calculateHeight(image)

					if(offset !== null){

						image.ST = GSAP.timeline({
							// yPercent: offset,
							// ease: "none",
						})

						image.ST = GSAP.to(image, {
							yPercent: offset,
							ease: "none",
							scrollTrigger: {
								trigger: image.parentNode,
								start: "top bottom",
								end: "bottom top",
								scrub: true,
								invalidateOnRefresh: true,
							}
						});

					}
				
				}
				
			});

		}

	}

	calculateHeight(image){

		const height = getComputedStyle(image).height.replace('px','') / getComputedStyle(image.parentElement).height.replace('px','') * 100;

		if(height > 100){
			// Based on this approach: https://codepen.io/kosalraj/pen/MWZdqEb
			const percentage = Math.round(height - 100);
			// const offset = percentage * 0.5;
			const offset = percentage;
			return offset;
		}
	}

}
